import { render } from "./validationErrors.vue?vue&type=template&id=c3e8c488"
import script from "./validationErrors.vue?vue&type=script&lang=js"
export * from "./validationErrors.vue?vue&type=script&lang=js"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__